// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"fe0e8a99","787":"9fd7bfcf"}[chunkId] + ".chunk.js";
};